import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import gsap from "gsap";
import colors from "styles/colors";
import text from "styles/text";
import media from "styles/media";
import { ScrollTrigger } from "gsap/all";
import { useMedia } from "utils/hooks";

type props = {
  children: any;
  left: boolean;
  background: string;
  loaded: boolean;
  animationClass: string;
  link: string;
};

const HybridBanner: React.FC<props> = ({ children, left, background, loaded, animationClass, link }) => {
  const inner = useRef<HTMLHeadingElement>(null);

  const bannerOffset = useMedia(0,-5,-5,-5)
  const animate = useMedia(true, true, true, false)

  const handleSocialClick = () => {
    window.open(link, 'blank')
  }
  
  useEffect(() => {
    if (inner.current && loaded && animate) {
      const elements = gsap.utils.toArray(animationClass);
      //controls how much speed is added on scroll. Higher = slower
      const divisor = 2000;
      const additionalX = { val: 0 };
      let containerWidth = window.innerWidth;
      let additionalXAnim: any;
      let offset = bannerOffset;

      elements.forEach((item: any) => {
        gsap.to(item, {
          x: left ? containerWidth : -containerWidth,
          duration: 20,
          repeat: -1,
          ease: "none",
          modifiers: {
            x: gsap.utils.unitize((x) => {
              offset += additionalX.val;
              x = (parseFloat(x) + offset) % -containerWidth;
              return x;
            }),
          },
        });
      });

      ScrollTrigger.create({
        trigger: "#Multi__Banner", 
        scroller: ".smooth-scroll",
        start: "top bottom",
        end: "bottom top",
        onUpdate: function (self) {
          const velocity = self.getVelocity();

          if (velocity > 0) {
            if (additionalXAnim) additionalXAnim.kill();

            additionalX.val = left ? velocity / divisor : -velocity / divisor;
            additionalXAnim = gsap.to(additionalX, { val: 0 });
          } else if (velocity < 0) {
            if (additionalXAnim) additionalXAnim.kill();
            additionalX.val = left ? velocity / divisor : -velocity / divisor;
            additionalXAnim = gsap.to(additionalX, { val: 0 });
          }
        },
      });
    }
  }, [animationClass, loaded, left, bannerOffset, animate]);

  return (
    <Wrapper onClick={handleSocialClick} data-scroll background={background}>
      <DigText ref={inner} left={left}>
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
        {children}
      </DigText>
    </Wrapper>
  );
};

export default HybridBanner;

const DigText = styled.h1<{ outlined?: boolean; left?: boolean }>`
  position: relative;
  display: flex;
  transform: translateX(${(props) => (props.left ? "-100%" : "0%")});
  ${text.desktop.h6}
  color: ${colors.pureBlack};
  cursor: none;
  pointer-events: none;
  text-transform: uppercase;
  ${media.tablet} {
    ${text.tablet.h6}
  }
  ${media.mobile} {
    ${text.mobile.h6}
  }
`;

const Wrapper = styled.div<{ background: string }>`
  position: relative;
  transform: translate3d(0,0,0);
  background: ${(props) => props.background};
  height: 3.4vw;
  transition: background 0.4s, padding 0.4s, height 0.4s;
  padding: 0.94vw 0;
  will-change: transform;
  cursor: none;
  ${media.hover} {
    :hover {
      height: 6.18vw;
      background: linear-gradient(90deg, white 0%, white 100%);
      transition: background 0.4s, padding 0.4s, height 0.4s;
      padding: 2.33vw 0;
    }
  }
  ${media.tablet} {
    height: 4.883vw;
    padding: 1.66vw 0;
    left: 0vw;
    top: 0;
    z-index: 10;
  }
  ${media.mobile} {
    height: 13.333vw;
    padding: 6vw 0;
    left: 0;
    top: 10.133vw;
  }
`;